import { render } from "./ToolItem.vue?vue&type=template&id=37a32ece"
import script from "./ToolItem.vue?vue&type=script&lang=js"
export * from "./ToolItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__